export const EARNINGS_LOAD_LIST = {
	START: 'EARNINGS_LOAD_LIST_START',
	DONE: 'EARNINGS_LOAD_LIST_DONE',
	FAIL: 'EARNINGS_LOAD_LIST_FAIL'
} as const

export type EarningsActionType = typeof EARNINGS_LOAD_LIST.START | typeof EARNINGS_LOAD_LIST.DONE | typeof EARNINGS_LOAD_LIST.FAIL
